"use client";
import React, { useState } from 'react';
import TestimonialCard from './TestimonialCard';

const NavigationArrow = ({ direction = 'left', onClick, className = '' }) => {
  const isLeft = direction === 'left';

  return (
    <button
      onClick={onClick}
      className={`flex items-center justify-center w-10 h-10 bg-white border border-neutral-300 rounded-full hover:bg-neutral-50 transition-colors duration-200 shadow-sm ${className}`}
      aria-label={`Navigate ${direction}`}
    >
      {isLeft ? (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.5 15L7.5 10L12.5 5"
            stroke="#4E5258"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 15L12.5 10L7.5 5"
            stroke="#4E5258"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </button>
  );
};

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      image: "https://api.builder.io/api/v1/image/assets/TEMP/e5ecad12aa6a0c7fae4665f4aa7b058a22150bbf?width=316",
      testimonial: "\"Absolutely thrilled with my purchase from Samyakk! The lehenga looked straight out of a fairytale and fit perfectly. The entire experience, from ordering to delivery, was smooth. Thank you for making me look and feel so beautiful!\"",
      name: "Shivani Pal",
      location: "MUMBAI"
    },
    {
      image: "https://api.builder.io/api/v1/image/assets/TEMP/646c1d7a98c8b8e5420882ee1ae70b8aa8657567?width=316",
      testimonial: "The customer service at Samyak is also exceptional. Their team is knowledgeable, responsive, and always willing to assist with any inquiries or customization requests. It's clear that they genuinely care about their customers and their satisfaction.",
      name: "Anita Rao MD",
      location: "DELHI"
    },
    {
      image: "https://api.builder.io/api/v1/image/assets/TEMP/e5ecad12aa6a0c7fae4665f4aa7b058a22150bbf?width=316",
      testimonial: "\"Absolutely thrilled with my purchase from Samyakk! The lehenga looked straight out of a fairytale and fit perfectly. The entire experience, from ordering to delivery, was smooth. Thank you for making me look and feel so beautiful!\"",
      name: "Shivani Pal",
      location: "MUMBAI"
    }
  ];

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : testimonials.length - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev < testimonials.length - 1 ? prev + 1 : 0));
  };

  return (
    <section
      className="flex flex-col items-center px-4 py-8 mx-auto w-full max-w-[1440px] mt-8 max-md:px-6 max-md:py-6 max-md:mt-10 max-sm:px-4 max-sm:py-6 max-sm:mt-10"
      role="region"
      aria-labelledby="testimonials-heading"
    >
      <header className="flex flex-col items-center w-full mb-12 max-sm:mb-8">
        <h2
          id="testimonials-heading"
          className="text-xl font-medium text-center text-neutral-700"
        >
          Client Diaries
        </h2>
      </header>

      {/* Desktop Layout - Two cards side by side with arrows positioned in middle */}
      <div className="hidden xl:flex items-center justify-center gap-8 w-full max-w-[1400px]">
        <div className="flex-shrink-0 self-center">
          <NavigationArrow
            direction="left"
            onClick={handlePrevious}
          />
        </div>

        <div className="flex gap-8 justify-center items-stretch flex-1 max-w-[1200px]">
          <div className="flex-1 max-w-[580px] flex">
            <TestimonialCard {...testimonials[0]} />
          </div>
          <div className="flex-1 max-w-[580px] flex">
            <TestimonialCard {...testimonials[1]} />
          </div>
        </div>

        <div className="flex-shrink-0 self-center">
          <NavigationArrow
            direction="right"
            onClick={handleNext}
          />
        </div>
      </div>

      {/* Mobile/Tablet Layout - One card at a time with carousel, arrows positioned in middle */}
      <div className="flex xl:hidden items-center justify-center gap-4 w-full">
        <div className="flex-shrink-0 self-center">
          <NavigationArrow
            direction="left"
            onClick={handlePrevious}
          />
        </div>

        <div className="overflow-hidden flex-1 max-w-[320px] md:max-w-[500px]">
          <div
            className="flex transition-transform duration-300 ease-in-out"
            style={{
              transform: `translateX(-${currentIndex * 100}%)`,
              height: 'auto'
            }}
          >
            {testimonials.map((testimonial, index) => (
              <div key={index} className="w-full flex-shrink-0 px-2 flex">
                <TestimonialCard {...testimonial} />
              </div>
            ))}
          </div>
        </div>

        <div className="flex-shrink-0 self-center">
          <NavigationArrow
            direction="right"
            onClick={handleNext}
          />
        </div>
      </div>

      {/* Mobile/Tablet Dots Indicator */}
      <div className="flex xl:hidden justify-center mt-6 space-x-2">
        {testimonials.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-2 h-2 rounded-full transition-colors duration-200 ${
              index === currentIndex ? 'bg-neutral-700' : 'bg-neutral-300'
            }`}
            aria-label={`Go to testimonial ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default TestimonialsSection;
